import { Formik } from 'formik'

import { useAccountLanguagesIds, useUpdateAccountLanguages } from 'src/hooks'
import { IAccountLanguagesForm } from 'src/types'
import { LanguagesForm } from './form.component'

interface IProps {
  handleClose: () => void
}

export const ModalInner = ({ handleClose }: IProps) => {
  const { data: languagesIds } = useAccountLanguagesIds()
  const { mutateAsync: updateAccountLanguages } = useUpdateAccountLanguages()

  if (!languagesIds) {
    return null
  }

  const handleSubmit = async (values: IAccountLanguagesForm) => {
    await updateAccountLanguages(values)
    handleClose()
  }

  return (
    <Formik initialValues={{ languagesIds }} onSubmit={handleSubmit}>
      <LanguagesForm />
    </Formik>
  )
}
